import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Image from 'next/image';
import { AgencyLogo, OffersCount, StyledAgencyCard, Title } from './styled';
import { Typography } from '../../ui/Typography';

export const AgencyCard = ({
  id,
  path,
  logoUrl,
  name,
  itemsCount,
  description
}) => {
  const { t } = useTranslation();
  const offersCount = t('sections.agencies.agencies_count_many', {
    count: itemsCount
  });

  return (
    <StyledAgencyCard
      key={id}
      href={path}
      data-cy="agency"
      data-stat="agency-card-link"
    >
      <AgencyLogo data-cy="agency-logo">
        <Image src={logoUrl} fill alt="" />
      </AgencyLogo>
      <div>
        <Title data-cy="agency-title">{name}</Title>
        <OffersCount data-cy="agency-count">{offersCount}</OffersCount>
        <Typography tag="caption_1" $lineToShow={3} data-cy="agency-desc">
          {description}
        </Typography>
      </div>
    </StyledAgencyCard>
  );
};

AgencyCard.propTypes = {
  id: PropTypes.string,
  path: PropTypes.string,
  name: PropTypes.string,
  logoUrl: PropTypes.string,
  description: PropTypes.string,
  itemsCount: PropTypes.number
};
